export default __webpack_public_path__ + "static/media/018-wine.f980c249.svg";